import React from "react";
import { Button, Col, Form, InputGroup, Row } from "react-bootstrap";
import Datetime from "react-datetime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEraser, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { format, isValid, parse } from "date-fns";
import { formatInTimeZone, zonedTimeToUtc } from "date-fns-tz";
import { PANEL_EVENT_TIME_ZONE } from "../assets/functions.js";

export const reportDateInputValue = (value, timeZone = PANEL_EVENT_TIME_ZONE) => {
  if (!value) return null;
  if (value instanceof Date) return new Date(value.getTime());
  const text = typeof value.format === "function" ? value.format("DD/MM/YYYY HH:mm") : String(value);
  const parsed = parse(text, "dd/MM/yyyy HH:mm", new Date());
  if (!isValid(parsed) || format(parsed, "dd/MM/yyyy HH:mm") !== text) return text;
  const instant = zonedTimeToUtc(format(parsed, "yyyy-MM-dd HH:mm:ss"), timeZone);
  return isValid(instant) && formatInTimeZone(instant, timeZone, "dd/MM/yyyy HH:mm") === text ? instant : text;
};

export default function ReportDateRangeFilter({ idPrefix, dateRange, onChange, onApply, onReset, startLabel, endLabel, timeZone = PANEL_EVENT_TIME_ZONE, children }) {
  return <Row className="mb-3 mx-0 gx-2 align-items-end">
    {children}
    {[
      { key: "startDate", label: startLabel },
      { key: "endDate", label: endLabel },
    ].map(({ key, label }) => <Form.Group as={Col} key={key} xs={12} sm={6} md={children ? 3 : 4} className="mb-3" controlId={`${idPrefix}-${key}`}>
      <Form.Label className="fw-bold">{label}</Form.Label>
      <InputGroup className="w-100 flex-nowrap">
        <div className="flex-fill">
          <Datetime
            value={dateRange?.[key] instanceof Date && isValid(dateRange[key]) ? formatInTimeZone(dateRange[key], timeZone, "dd/MM/yyyy HH:mm") : dateRange?.[key] || ""}
            onChange={(value) => {
              const parsedValue = reportDateInputValue(value, timeZone);
              if (key === "endDate" && parsedValue instanceof Date && isValid(parsedValue)) parsedValue.setUTCSeconds(59, 999);
              onChange(key, parsedValue);
            }}
            dateFormat="DD/MM/YYYY"
            timeFormat="HH:mm"
            inputProps={{ id: `${idPrefix}-${key}`, placeholder: "dd/MM/yyyy HH:mm", className: "form-control", style: { borderTopRightRadius: 0, borderBottomRightRadius: 0 } }}
            locale="pt-br"
          />
        </div>
        <InputGroup.Text as="button" type="button" onClick={onApply} aria-label={`Aplicar período: ${label}`}>
          <FontAwesomeIcon icon={faMagnifyingGlass} />
        </InputGroup.Text>
      </InputGroup>
    </Form.Group>)}
    <Col xs="auto" md={2} className="d-flex align-items-end mb-3">
      <Button variant="primary" onClick={onReset} title="Restaurar período padrão" aria-label={`Restaurar período padrão: ${startLabel}`}>
        <FontAwesomeIcon icon={faEraser} />
      </Button>
    </Col>
  </Row>;
}
